import { PDFDownloadLink } from "@react-pdf/renderer";
import ReportPDF from "./RepasseReportPDFRealizadoDetailsNormal";
import { getCurrentDateTime } from "../utils/getCurrentDateTime";

const DownloadButton = ({ dataPayments, rawData }) => {
  const currentDateTime = getCurrentDateTime();
  const fileName = `relatorio_medico_solicitante_administrativo_${currentDateTime}.pdf`;
  const title = "Relatório Médico Solicitante (Administrativo)"

  return (
    <PDFDownloadLink
      document={<ReportPDF payment={dataPayments} data={rawData || []} title={title} />}
      fileName={fileName}>
      {({ loading }) =>
        loading
          ? "Gerando PDF..."
          : "Baixar PDF (SOLICITANTE - ADMINISTRATIVO) "
      }
    </PDFDownloadLink>
  );
};

export default DownloadButton;
